<template>
  <div id="onboarding-backdoc" class="fade-in">
    <StepInfo btnText="Tirar foto do verso" @btnClick="actionEvent">
      <h2>Verso do documento</h2>
      <p>
        Detectamos que você enviou a frente do seu RG. Agora é necessário
        enviar a foto do verso do documento.
      </p>

      <div class="onboarding-image">
        <Asset
          name="backdoc.svg"
          alt="Verso do documento"
          title="Verso do documento"
        />
      </div>
    </StepInfo>
  </div>
</template>

<script>
import Asset from '@/components/common/Asset.vue';

import StepInfo from '../components/StepInfo.vue';

export default {
  name: 'onboarding-backdoc',
  components: { StepInfo, Asset },
  methods: {
    actionEvent() {
      this.$router.replace({
        name: 'onboarding-backdoc-camera',
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  #onboarding-backdoc {
    h2 {
      color: var(--gray-600);
      margin-top: 24px;
    }

    p {
      @extend .lead;
      margin: 19px 0px 36px 0px;
      line-height: 26px;
    }

    .onboarding-image {
      display: flex;
      justify-content: center;
    }
  }
</style>
